// File: src/store/adminEvents.js
import { createAsyncThunk, createReducer } from '@reduxjs/toolkit'
import { API, SCOPE_ADMIN_EVENTS, SCOPE_USFCR_STAFF } from '../../constants'
import { INITIAL_LIST_STATE_EXTENDED } from '../helpers/common'
import { application } from '../../services/application'
import { extendListBuilder, generateListActions } from '../helpers/listActionsHelpers'

// initial state for admin events list
export const INITIAL_STATE = {
  ...INITIAL_LIST_STATE_EXTENDED,
  order: ['createdAt', 'desc'],
}

// generate list actions for AdminEvents
const listActions = generateListActions({
  scope: SCOPE_USFCR_STAFF,
  apiMethod: {
    GET_LIST: API.USFCR_STAFF.GET_ADMIN_EVENTS,
  },
  getStore: store => store.adminEvents,
})

// export actions (e.g. fetchList, changePage, changeFilters, changeOrdering)
export const actions = {
  ...listActions,
}

// reducer: builds list handlers for AdminEvents
export default createReducer(INITIAL_STATE, builder => {
  return extendListBuilder(builder, actions)
})